import {StageState} from "../types/StageState";

export const state: StageState = {
    state: "",
    sessionsForAnnonce: [],
    upcomingSessions: []
}